<template>
    <div>
        <div class="modal-header readonly_header">
            <div class="mheading_1">
                <i class="fa fa-chevron-left modal-goback" @click="close"></i>
            </div>
            <div class="mheading_2">
                <h5 class="modal-title">{{ firstName + ' ' + lastName }}</h5>
                <h6 class="uemail">{{ email }}</h6>
                <h6 class="accountname">{{ accountName }}</h6>
                <!-- <hr class="hr_line" /> -->
            </div>
            <div class="mheading_4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>
        <div class="modal-body user-info">
            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
            <div class="pad-15">
                <div class="row edit_row">
                    <div class="assigned_heading_1 font-weight-bold">
                        Assessments&nbsp;
                        <a href="javascript:void(0)" class="see-more" v-if="assignedAssessmentsCount > 3 && assignedAssessmentsCount > 0" @click="showMoreAssessments">{{see_more_assessments_text}}</a>
                    </div>
                    <div class="assigned_heading_2 font-weight-bold text-center">Results</div>
                    <div class="clearfix"></div>

                    <div v-if="show_more_assessments === false && assignedAssessmentsCount > 0" class="row_item_readonly">
                        <div v-for="(item, lacindex) in lessAssignedAssessments" :key="lacindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.title }}</div>
                            <div class="assigned_heading_2 text-center">
                                <router-link target="_blank" v-if="item.complete_attempt_id" :to="'/assessment-report/' + item.complete_attempt_id" class="link_btn_highlight">
                                View
                                </router-link>
                                <span v-else>n/a</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="show_more_assessments === true && assignedAssessmentsCount > 0" class="row_item_readonly">
                        <div v-for="(item, acindex) in lessAssignedAssessments" :key="acindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.title }}</div>
                            <div class="assigned_heading_2 text-center">
                                <router-link target="_blank" v-if="item.complete_attempt_id" :to="'/assessment-report/' + item.complete_attempt_id" class="link_btn_highlight">
                                View
                                </router-link>
                                <span v-else>n/a</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="assignedAssessmentsCount === 0">
                        <div class="row_item_readonly justify-content-md-center">
                            <div class="text-red text-center">{{ getNoRecordText(assignedAssessmentsCount, 'Assessment') }}</div>
                        </div>
                    </div>
                </div>
                <div class="row edit_row">
                    <div class="assigned_heading_1 font-weight-bold">
                        Forms&nbsp;
                        <a href="javascript:void(0)" class="see-more" v-if="assignedFormsCount > 3 && assignedFormsCount > 0" @click="showMoreForms">{{see_more_forms_text}}</a>
                    </div>
                    <div class="assigned_heading_2 font-weight-bold text-center">Results</div>
                    <div class="clearfix"></div>
                    <div v-if="show_more_forms === false && assignedFormsCount > 0" class="row_item_readonly">
                        <div v-for="(item, lacindex) in lessAssignedForms" :key="lacindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.name }}</div>
                            <div class="assigned_heading_2 text-center">
                                <a href="javascript:void(0)" class="link_btn_highlight" v-on:click="goToViewForm(item.id)">View</a>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="show_more_forms === true && assignedFormsCount > 0" class="row_item_readonly">
                        <div v-for="(item, acindex) in assignedForms" :key="acindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.name }}</div>
                            <div class="assigned_heading_2 text-center">
                                <a href="javascript:void(0)" class="link_btn_highlight" v-on:click="goToViewForm(item.id)">View</a>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="assignedFormsCount === 0">
                        <div class="row_item_readonly justify-content-md-center">
                            <div class="text-red text-center">{{ getNoRecordText(assignedFormsCount, 'Form') }}</div>
                        </div>
                    </div>
                </div>
                <div class="row edit_row">
                    <div class="assigned_head_1 font-weight-bold">
                        Courses&nbsp;
                        <a href="javascript:void(0)" class="see-more" v-if="assignedCoursesCount > 3 && assignedCoursesCount > 0" @click="showMoreCourses">{{see_more_courses_text}}</a>
                    </div>
                    <div class="assigned_head_2 text-center font-weight-bold">Final Exam Score</div>
                    <div class="assigned_head_3 font-weight-bold">Certificate</div>
                    <div class="clearfix"></div>

                    <div v-if="show_more_courses === false && assignedCoursesCount > 0" class="row_item_readonly">
                        <div v-for="(item, lacindex) in lessAssignedCourses" :key="lacindex" class="row_data_border">
                            <div class="courses_item_1">
                                {{ item.title }}
                                <span v-if=item.score>
                                    <a class="show_icon" :ref="'show_icon_'+lacindex" @click="getCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + lacindex, lacindex)">
                                        <img 
                                            src="@/assets/enterprise/down_arrow_image16x16.png" 
                                            width="16" 
                                            height="16">
                                    </a>
                                    <a class="hide_icon" :ref="'hide_icon_'+lacindex" @click="hideCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + lacindex, lacindex)"> 
                                        <img 
                                            src="@/assets/enterprise/up_arrow_image16x16.png" 
                                            width="16" 
                                            height="16">
                                    </a>
                                </span>
                            </div>
                            <div class="courses_item_2 text-center"> 
                                <span v-if="item.score">{{ item.score }}%</span>
                                <span v-else>n/a</span>
                            </div>
                            <div class="courses_item_3 text-center" v-if="item.certification_download_link">
                                <a :href="item.certification_download_link" target="_blank" class="link_btn_highlight">View</a>
                            </div>
                            <div class="courses_item_3 text-center" v-else>n/a</div>
                            <div class="clearfix"></div>
                            <!-- modules start -->
                            <CourseUserResultsModules
                                :ref="'course_user_results_modules_' + lacindex"
                            >
                            </CourseUserResultsModules>
                            <!-- modules end -->
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="show_more_courses === true && assignedCoursesCount > 0" class="row_item_readonly">
                        <div v-for="(item, acindex) in assignedCourses" :key="acindex" class="row_data_border">
                            <div class="courses_item_1">
                                {{ item.title }}
                                <a class="show_icon" :ref="'show_icon_'+acindex" @click="getCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + acindex, acindex)">
                                    <img 
                                        src="@/assets/enterprise/down_arrow_image16x16.png" 
                                        width="16" 
                                        height="16">
                                </a>
                                <a class="hide_icon" :ref="'hide_icon_'+acindex" @click="hideCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + acindex, acindex)"> 
                                    <img 
                                        src="@/assets/enterprise/up_arrow_image16x16.png" 
                                        width="16" 
                                        height="16">
                                </a>
                            </div>
                            <div class="courses_item_2 text-center">
                                <span v-if="item.score">{{ item.score }}%</span>
                                <span v-else>n/a</span>
                            </div>
                            <div class="courses_item_3 text-center" v-if="item.certification_download_link">
                                <a :href="item.certification_download_link" target="_blank" class="link_btn_highlight">View</a>
                            </div>
                            <div class="courses_item_3 text-center" v-else>n/a</div>
                            <div class="clearfix"></div>
                            <!-- modules start -->
                            <CourseUserResultsModules
                                :ref="'course_user_results_modules_' + acindex"
                            >
                            </CourseUserResultsModules>
                            <!-- modules end -->
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="assignedCoursesCount === 0">
                        <div class="row_item_readonly justify-content-md-center">
                            <div class="text-red text-center">{{ getNoRecordText(assignedCoursesCount, 'Course') }}</div>
                        </div>
                    </div>

                </div>
                <div class="row edit_row" v-if="userType === 'mentee' || userType === 'apprentice'">
                    <div class="assigned_heading_1 font-weight-bold">
                         Task Lists&nbsp;
                        <a href="javascript:void(0)" class="see-more" v-if="assignedTaskListsCount > 3 && assignedTaskListsCount > 0" @click="showMoreTaskLists">{{see_more_tasklists_text}}</a>
                    </div>
                    <div class="assigned_heading_2 font-weight-bold text-center">Results</div>
                    <div class="clearfix"></div>
                    <div v-if="show_more_tasklists === false && assignedTaskListsCount > 0" class="row_item_readonly">
                        <div v-for="(item, lacindex) in lessAssignedTaskLists" :key="lacindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.name }}</div>
                            <div class="assigned_heading_2 text-center">
                                <router-link :to="'/enterprise-admin/mentees-task/' + accountId + '/' + userId" class="link_btn_highlight">
                                    View 
                                </router-link>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="show_more_tasklists === true && assignedTaskListsCount > 0" class="row_item_readonly">
                        <div v-for="(item, acindex) in assignedTaskLists" :key="acindex" class="row_data_border">
                            <div class="assigned_heading_1">{{ item.name }}</div>
                            <div class="assigned_heading_2 text-center">
                                <router-link :to="'/enterprise-admin/mentees-task/' + accountId + '/' + userId" class="link_btn_highlight">
                                    View 
                                </router-link>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="assignedTaskListsCount === 0">
                        <div class="row_item_readonly justify-content-md-center">
                            <div class="text-red text-center">{{ getNoRecordText(assignedTaskListsCount, 'Task List') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer"></div>
    </div>
</template>
<script>
import axios from 'axios';
import CourseUserResultsModules from './course_user_results_modules.vue';

export default {
    props: ['userId', 'readOnly','isUserDetailPanel', 'accountId'],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phoneNo: '',
            status: '',
            accountName: '',
            userType:'',
            assignedTaskLists: [],
            lessAssignedTaskLists: [],
            assignedTaskListsCount: 0,
            assignedAssessments: [],
            lessAssignedAssessments: [],
            assignedAssessmentsCount: 0,
            assignedCourses: [],
            lessAssignedCourses: [],
            assignedCoursesCount: 0,
            assignedForms: [],
            lessAssignedForms: [],
            assignedFormsCount: 0,
            see_more_tasklists_text: 'See all',
            see_more_assessments_text: 'See all',
            see_more_courses_text: 'See all',
            see_more_forms_text: 'See all',
            show_more_tasklists: false,
            show_more_assessments: false,
            show_more_courses: false,
            show_more_forms: false,
            loading: false,
            status_text_color: 'text-green',
            courseSelected: [],
            courses_modules: [],
            showModule: false,
            showIcon: [],
            course_msg: '',
            isResponseStatus: false,
        }
    },
    components: {
        CourseUserResultsModules,
    },
    methods: {
        close() {
            this.$parent.closeUserDetail();
        },
        capitalizeFirstLetter(string) {
            if (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        phoneNumberFormat() {
            var phone_val = this.phoneNo;
            this.phoneNo = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneNumberValidRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        formatStatus(status) {
            var status_text = 'Activate';
            if (status == 'ACTIVE' || status == 'Active') {
                status_text = 'Inactivate';
                this.status_text_color = 'text-red';
            }
            return status_text;
        },
        showMoreTaskLists() {
            if (!this.show_more_tasklists) {
                this.show_more_tasklists = true;
                this.see_more_tasklists_text = 'See less';
            } else {
                this.show_more_tasklists = false;
                this.see_more_tasklists_text = 'See all';
            }
        },
        showMoreAssessments() {
            if (!this.show_more_assessments) {
                this.show_more_assessments = true;
                this.see_more_assessments_text = 'See less';
            } else {
                this.show_more_assessments = false;
                this.see_more_assessments_text = 'See all';
            }
        },
        showMoreCourses() {
            if (!this.show_more_courses) {
                this.show_more_courses = true;
                this.see_more_courses_text = 'See less';
            } else {
                this.show_more_courses = false;
                this.see_more_courses_text = 'See all';
            }
        },
        showMoreForms() {
            if (!this.show_more_forms) {
                this.show_more_forms = true;
                this.see_more_forms_text = 'See less';
            } else {
                this.show_more_forms = false;
                this.see_more_forms_text = 'See all';
            }
        },
        goToViewForm(formId) {
            axios.get('/desktop/forms-manager/view-form/'+formId+'/'+this.accountId, {
            })
            .then(response =>  {        
                window.open(process.env.API_ENDPOINT + '/forms/' +response.data.filepath, '_blank');                        
            })
            .catch(function(err) {
                //console.log("Come here"+ err);
            });
        },
        getNoRecordText(count, textMsg) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.isResponseStatus) {
                    return "No " + textMsg + " Found.";
                }
            }
        },
        getCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('show_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('hide_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.add('show_icon');
            
            // console.log(elementName)
            // console.log(this.$refs[elementName][0])
            this.$refs[elementName][0].getModules(userId, courseId, true);
        },
        hideCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('show_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('show_icon');
            this.$refs['hide_icon_' + index][0].classList.add('hide_icon');
            
            this.$refs[elementName][0].getModules(userId, courseId, false);
        },
    },
    created() {
        this.loading = true;
        axios.get('/enteprise-admin/user-details/' + this.userId + '/' + this.accountId, {
            params: { enterprise_type: 'readonly' }
        })
        .then(response =>  {
            this.isResponseStatus = true;
            this.loading = false;
            this.firstName = this.capitalizeFirstLetter(response.data.first_name);
            this.lastName = this.capitalizeFirstLetter(response.data.last_name);
            this.email = response.data.email;
            this.phoneNo = response.data.phone_no;
            this.status = response.data.status;
            this.userType = response.data.user_type;
            this.accountName = response.data.account_name;

            this.assignedTaskLists = response.data.user_tasklist;
            this.assignedTaskListsCount = response.data.user_tasklist.length;
            if(this.assignedTaskListsCount > 3) {
                for( var i=0; i< 3; i++) {
                    this.lessAssignedTaskLists[i] = response.data.user_tasklist[i];
                }
            }
            else {
                for( var j=0; j< this.assignedTaskListsCount; j++) {
                    this.lessAssignedTaskLists[j] = response.data.user_tasklist[j];
                }
            }
            this.assignedAssessments = response.data.user_assessments;
            this.assignedAssessmentsCount = response.data.user_assessments.length;
            if(this.assignedAssessmentsCount > 3) {
                for( var i=0; i< 3; i++) {
                    this.lessAssignedAssessments[i] = response.data.user_assessments[i];
                }
            }
            else {
                for( var j=0; j< this.assignedAssessmentsCount; j++) {
                    this.lessAssignedAssessments[j] = response.data.user_assessments[j];
                }
            }
            this.assignedCourses = response.data.user_courses;
            this.assignedCoursesCount = response.data.user_courses.length;
            if(this.assignedCoursesCount > 3) {
                for( var i=0; i< 3; i++) {
                    this.lessAssignedCourses[i] = response.data.user_courses[i];
                }
            }
            else {
                for( var j=0; j< this.assignedCoursesCount; j++) {
                    this.lessAssignedCourses[j] = response.data.user_courses[j];
                }
            }

            this.assignedForms = response.data.user_forms;
            this.assignedFormsCount = response.data.user_forms.length;
            if(this.assignedFormsCount > 3) {
                for( var i=0; i< 3; i++) {
                    this.lessAssignedForms[i] = response.data.user_forms[i];
                }
            }
            else {
                for( var j=0; j< this.assignedFormsCount; j++) {
                    this.lessAssignedForms[j] = response.data.user_forms[j];
                }
            }

        })
        .catch(function(error) {
            //console.log(error);
        });
    }
}
</script>
<style scoped>
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header { border-bottom: none; }
.modal-title { font-weight: 900; }
.modal-footer { border-top: none; }
.readonly_header { padding: 0 1rem; }
.user-info { padding: 0.5rem 1.5rem !important; }
.user-info::before {
    content: "";
    display: block;
    width: 97%;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.uemail { font-size: 12px; font-style: italic; margin: 2px 0; }
.accountname { font-size: 13px; font-weight: 900; margin: 4px 0 10px 0; }
.mheading_1 { width: 5%; }
.mheading_2 { width: 85%; }
.mheading_3 { 
    width: 5%;
    margin: 15px 50px 0 0;
    font-size: 15px;
    font-weight: 900;
    color: #00Acee; 
}
.mheading_4 { width: 5%; }
.link_btn { color: #00acee !important; font-weight: 900; cursor: pointer; }
.input_label { font-weight: 900; }
.edit_row { width: 95%; margin-top: 10px; }
.finput { background-color: #efefef !important; height: calc(1.15em + 0.75rem + 2px) !important; font-size: 0.9rem !important; }
.text-green { color: #28a745; font-weight: 900; }
.text-red { color: #dc3545; font-weight: 900; }
.hr_line { 
    margin: 0px -50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
 }
.assigned_heading_1 { width: 90%; float: left; }
.assigned_heading_2 { width: 10%; float: left; }
.assigned_head_1 { width: 60%; float: left; }
.assigned_head_2 { width: 30%; float: left; }
.assigned_head_3 { width: 10%; float: left; }
.assigned_thead_1 { width: 90%; float: left; }
.pad-15 { padding: 0 15px; }
.row_item_readonly { width: 100%; margin: 10px 0; padding: 0 0 0 10px; }
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.link_btn_highlight { color: #00acee !important; font-weight: 900; cursor: pointer; text-decoration: underline; }
.courses_item_1 { width: 60%; float: left; }
.courses_item_2 { width: 30%; float: left; }
.courses_item_3 { width: 10%; float: left; }
.show_icon { 
  display: show;
}
.hide_icon { 
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/view_user_detail_readonly.vue